module.exports = "<div class=\"partner-card\">\n  <a class=\"partner-card-link\" [href]=\"link.link\" target=\"_blank\"\n     [ngStyle]=\"{'background-image': 'url(' + link.image + ')'}\">\n    <div class=\"partner-card-hover\">\n      <div class=\"partner-card-hover__info\">\n        <h4 class=\"partner-card-hover__info__title\">{{link.title}}</h4>\n        <p class=\"partner-card-hover__info__p\">\n          {{link.description}}\n        </p>\n      </div>\n    </div>\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/heyground/partners/partner-link-item/partner-link-item.component.html
// module id = 1081
// module chunks = 0